import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Faqs } from 'components/Faqs';
import { faqItems } from 'sections/Resources/DemurrageAndDetention/data';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionFaq/SectionFaq.module.scss';

const cn = classNames.bind(styles);

const SectionFaq = (): ReactElement => {
  return (
    <section className={cn('faq')}>
      <div className={cn('container')}>
        <h2 className={cn('faq__title')}>
          FAQs About Demurrage and Detention
        </h2>
        <div className={cn('faq__list-container')}>
          <Faqs faqsData={faqItems} />
        </div>
      </div>
    </section>
  );
};

export default SectionFaq;
